import styled from 'styled-components';
import { breakpoints, spacing } from 'components/Theme';
import { asRem } from 'utils';
import { Section } from 'Container';

export const BenefitStyle = styled(Section)`
  .row {
    padding-top: ${asRem(spacing.four)};

    @media (min-width: ${breakpoints.md}) {
      padding-top: ${asRem(spacing.two)};
    }
  }
`;
